export default {
  sm: `
  기술로 신뢰를 쌓는
  데이터센터 각
  `,
};
